
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/homeowners",
      function () {
        return require("private-next-pages/fr/homeowners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/homeowners"])
      });
    }
  